import type { History } from 'history';

interface ReplaceSearchParamIfChangedOptions {
  history: Pick<History, 'replace'>;
  pathname: string;
  search: string;
  key: string;
  value: string;
}

export const replaceSearchParamIfChanged = ({
  history,
  pathname,
  search,
  key,
  value,
}: ReplaceSearchParamIfChangedOptions): boolean => {
  const params = new URLSearchParams(search);

  if (params.get(key) === value) return false;

  params.set(key, value);
  history.replace({
    pathname,
    search: params.toString(),
  });

  return true;
};
